export const INVENTORY_INGREDIENT_SUBSCRIPTION_STATUS =
  'INVENTORY_INGREDIENT_SUBSCRIPTION_STATUS';
export const INVENTORY_INGREDIENT_SET_SUBSCRIPTION_STATUS =
  'INVENTORY_INGREDIENT_SET_SUBSCRIPTION_STATUS';
